import { render, staticRenderFns } from "./ReferenceTables.vue?vue&type=template&id=8784be18&scoped=true"
import script from "./ReferenceTables.vue?vue&type=script&lang=js"
export * from "./ReferenceTables.vue?vue&type=script&lang=js"
import style0 from "./ReferenceTables.vue?vue&type=style&index=0&id=8784be18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8784be18",
  null
  
)

export default component.exports